/// <reference types="vite/client" />

const env = {
  API_URL: import.meta.env.VITE_API_URL ?? "",
  APP_NAME: import.meta.env.VITE_APP_NAME ?? "Etsy Research Copilot",
  APP_VERSION: import.meta.env.VITE_APP_VERSION ?? "1.0.0",
  IS_DEV: import.meta.env.DEV,
};

export default env;
